import { createActions, createAction } from 'redux-actions';
export var createCustomerComplete = createActions('CREATE_CUSTOMER_COMPLETE').createCustomerComplete;
export var createCustomer = createAction('CREATE_CUSTOMER', function (payload) { return payload; }, function (payload, sessionUuid) { return ({
    sessionUuid: sessionUuid,
}); });
